<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapState, mapGetters, mapActions } from "vuex";
import Swal from "sweetalert2";
import DataTable from "@/components/DataTable.vue";
import { ModelListSelect } from "vue-search-select";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Stock Returns",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    DataTable,
    ModelListSelect,
  },
  data() {
    return {
      title: "Stock Returns",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Stock Returns",
          active: true,
        },
      ],
      totalRows: 1,

      pageOptions: [10, 25, 50, 100, 200, 1000],
      serverPerPage: 50,
      IsStockreturnsServerPaginated: true,
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "product",
          sortable: true,
          label: "PRODUCT",
        },
        {
          key: "quantity",
          sortable: true,
          label: "QUANTITY",
        },
        {
          key: "unit",
          sortable: true,
          label: "UNITS",
        },
        {
          key: "agent",
          sortable: true,
          label: "AGENT",
        },
        {
          key: "user.name",
          sortable: true,
          label: "RECORDED By",
        },
        {
          key: "date",
          sortable: true,
          label: "RETURNED ON",
        },
      ],
      filterStockReturns: {
        agent_id: 0,
        page: 1,
        per_page: 50,
      },
    };
  },

  computed: {
    // MAP STATE
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("agentstock", [
      "SaveStatus",
      "Stockreturns",
      "StockreturnsPagination",
      "StockreturnsPaginated",
      "FilterStatus",
      "Agents",
    ]),
    ...mapGetters("auth", ["MyUserPerm"]),

    rows() {
      return this.IsStockreturnsServerPaginated
        ? (this.StockreturnsPagination && this.StockreturnsPagination?.total) ||
            0
        : this.Stockreturns
        ? this.Stockreturns.length
        : 0;
    },

    perPage: {
      get() {
        if (this.IsStockreturnsServerPaginated) {
          return (
            (this.StockreturnsPagination &&
              this.StockreturnsPagination.per_page) ||
            this.filterStockReturns.per_page ||
            this.serverPerPage
          );
        } else {
          return this.serverPerPage;
        }
      },
      set(value) {
        if (this.IsStockreturnsServerPaginated) {
          this.filterStockReturns.per_page = value;
          this.filterStockReturns.page = 1;
          this.FetchStockReturn(this.filterStockReturns);
        }
      },
    },
    currentPage: {
      get() {
        if (this.IsStockreturnsServerPaginated) {
          return (
            (this.StockreturnsPagination &&
              this.StockreturnsPagination.current_page) ||
            this.filterStockReturns.page ||
            1
          );
        } else {
          return 1;
        }
      },
      set(value) {
        if (this.IsStockreturnsServerPaginated) {
          this.filterStockReturns.page = value;
          this.FetchStockReturn(this.filterStockReturns);
        }
      },
    },
  },

  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeModal(this.modal_id);
        if (this.type == "success") {
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },

  methods: {
    ...mapActions({
      FetchStockReturn: "agentstock/fetchAgentstockReturns",
      FetchAgents: "agentstock/fetchAgents",
    }),
    FilterReport() {
      this.filterStockReturns.page = 1;
      this.FetchStockReturn(this.filterStockReturns);
    },
  },

  created() {
    this.FetchStockReturn(this.filterStockReturns);
    this.FetchAgents();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <div class="col-md-4 form-group">
                <label>SELECT AGENT</label>

                <model-list-select
                  :list="
                    Agents
                      ? [{ id: 0, name: 'All Agents' }, ...Agents]
                      : [{ id: 0, name: 'All Agents' }]
                  "
                  v-model="filterStockReturns.agent_id"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Agent"
                  @input="FilterReport()"
                >
                </model-list-select>
              </div>
              <div class="col-md-2 mt-4">
                <button
                  class="btn btn-primary"
                  type="button"
                  @click="FilterReport()"
                >
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner
                    v-show="SaveStatus"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner>
                </button>
              </div>
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0 mt-3">
              <DataTable
                :columns="fields"
                :rows="Stockreturns || []"
                :total-rows="rows"
                :pagination="StockreturnsPagination"
                :server-pagination="IsStockreturnsServerPaginated"
                :loading="FilterStatus"
              >
                <template #cell(index)="{ index }">
                  {{ (currentPage - 1) * perPage + index + 1 }}
                </template>
                <template #cell(product)="{ row }">
                  {{ row.product }}
                </template>
                <template #cell(quantity)="{ row }">
                  {{ row.quantity }}
                </template>
                <template #cell(unit)="{ row }">
                  {{ row.unit }}
                </template>
                <template #cell(agent)="{ row }">
                  {{ row.agent }}
                </template>
                <template #cell(user.name)="{ row }">
                  {{ row.user.name }}
                </template>
                <template #cell(date)="{ row }">
                  {{ row.date }}
                </template>
              </DataTable>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}
</style>
